export default {
  "nav.home": "首页",
  "nav.category": "分类",
  "nav.article": "资讯",
  "nav.about": "关于我们",
  "nav.search": "搜索漫画...",
  "breadcrumb.home": "首页",
  "footer.subscribe_title": "订阅我们的 newsletter",
  "footer.subscribe_desc": "获取最新韩漫更新通知和独家推荐",
  "footer.subscribe_placeholder": "输入您的邮箱",
  "footer.subscribe_btn": "订阅",
  "footer.quick_links": "快速链接",
  "footer.contact": "联系我们",
  "footer.phone": "电话：400-888-0000",
  "footer.email": "邮箱：hello@xinxiust.com",
  "footer.office": "办公地址",
  "footer.address": "北京市朝阳区望京SOHO T3-A 2501",
  "footer.copyright": "© 2026 在线漫画韩漫. 保留所有权利.",
  "footer.privacy": "隐私政策",
  "footer.terms": "服务条款",
  "footer.social_weibo": "微博",
  "footer.social_wechat": "微信",
  "footer.social_bilibili": "哔哩哔哩",
  "footer.subscribe_success": "订阅成功！感谢您的关注。",
  "footer.subscribe_error": "订阅失败，请稍后再试。",
  "cta.start_reading": "开始阅读",
  "cta.view_all": "查看全部",
  "cta.load_more": "加载更多",
  "cta.read_now": "立即阅读",
  "tag.hot": "热门",
  "tag.new": "新作",
  "tag.recommend": "推荐",
  "tag.completed": "已完结",
  "tag.ongoing": "连载中",
};